module.exports = __webpack_public_path__ + "static/media/60.4c09e52a.wav";